import { useEffect, useState } from 'react';

interface Return {
  targetsHeight: number;
}
export const useTargetsDomHeight = (elementByIds: string[]): Return => {
  const [targetsHeight, setTargetsHeight] = useState<number>(0);

  useEffect(() => {
    let totalHeight = 0;
    elementByIds.forEach((elementById) => {
      totalHeight += document.getElementById(elementById)?.offsetHeight ?? 0;
    });

    setTargetsHeight(totalHeight);
  }, [elementByIds]);

  return { targetsHeight };
};
